import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/3_card_back_red/3_card_back_red"
 * Contains 1 texture(s)
 */
export class CardsBacks3CardBackRedAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/3_card_back_red/3_card_back_red';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '3_red.png'
    ] as const;
}
